import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { InfoCircle } from 'react-bootstrap-icons'

const InfoTooltip = ({ message }) => {
    return (
        <OverlayTrigger
            placement='right'
            overlay={
                <Tooltip id='tooltip-info'>
                    {message}
                </Tooltip>
            }
        >
            <span style={{ cursor: "pointer", marginLeft: "6px", color: "#0d6efd" }}>
                <InfoCircle size={18} />
            </span>
        </OverlayTrigger>
    )
}

export default InfoTooltip
